export function headerNestNav() {
  if(!IS_TOUCH) {
    $('.js-global-parent').on('mouseenter', function() {
      if($(window).width() > 767) {
        const $this = $(this);
        const $parent = $this.closest('.js-global-container');
        const $nest = $parent.find('.js-global-nest');
        $this.addClass('is-select');
        $nest.addClass('is-show');
      }
    });
    $('.js-global-container').on('mouseleave', function() {
      if($(window).width() > 767) {
        const $this = $(this);
        const $button = $this.find('.js-global-parent');
        const $nest = $this.find('.js-global-nest');
        $button.removeClass('is-select');
        $nest.removeClass('is-show');
      }
    });
  } else {
    $('.js-global-parent').on('click', function() {
      if($(window).width() > 767) {
        const $this = $(this);
        const $parent = $this.closest('.js-global-container');
        const $nest = $parent.find('.js-global-nest');
        $this.toggleClass('is-select');
        $nest.toggleClass('is-show');
        return false;
      } else {
        $('.js-global-parent').attr('target', '_self');
      }
    });
  }
  $('.js-nest-trigger').on('click', function() {
    const $this = $(this);
    const $parent = $this.closest('.js-global-container');
    const $nest = $parent.find('.js-global-nest');
    $this.toggleClass('is-current');
    $nest.toggleClass('is-show');
    return false;
  });
}